import { useEffect } from 'react';

var useScript = function useScript(content, id) {
  var dependents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text/javascript';
  var target = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : document.head;
  useEffect(function () {
    if (document.head.querySelector("#".concat(id)) !== null) {
      return function () {};
    }

    var script = document.createElement('script');
    script.type = type;
    script.id = id;
    script.appendChild(document.createTextNode(content));
    target.appendChild(script);
    return function () {
      target.removeChild(script);
    };
  }, dependents); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useScript };